module.exports = {
	"root": "findify-components--pagination",
	"prev": "findify-components--pagination__prev",
	"next": "findify-components--pagination__next",
	"first": "findify-components--pagination__first",
	"last": "findify-components--pagination__last",
	"page": "findify-components--pagination__page",
	"dots": "findify-components--pagination__dots",
	"active": "findify-components--pagination__active"
};